import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="max-w-3xl">
      <h2 className="text-3xl font-bold text-black mb-8">Impressum</h2>
      <div className="space-y-6 text-gray-700">
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Angaben gemäß § 5 TMG</h3>
          <p>
            Nadine Rau u. Mike Trepte GbR<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Vertreten durch</h3>
          <p>
            Geschäftsführer: Nadine Rau, Mike Trepte<br />
            Verantwortlich gem. §10, A3 MDStV: Mike Trepte
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Kontakt</h3>
          <p>
            Telefon: 0561 / 43027276<br />
            E-Mail: mike.trepte@ki-kundenkommunikation.de
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Umsatzsteuer-ID</h3>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            DE338605405
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">
            Berufsbezeichnung und berufsrechtliche Regelungen
          </h3>
          <p>
            Berufsbezeichnung: Unternehmensberatung<br />
            Zuständige Kammer: IHK Kassel-Marburg
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Redaktionell verantwortlich</h3>
          <p>
            Mike Trepte<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;